var map = {
	"./year_report_ar.json": 6394,
	"./year_report_br.json": 1525,
	"./year_report_de.json": 9358,
	"./year_report_en.json": 2723,
	"./year_report_es.json": 2430,
	"./year_report_fr.json": 5055,
	"./year_report_id.json": 7143,
	"./year_report_it.json": 7842,
	"./year_report_ja.json": 6251,
	"./year_report_nl.json": 4769,
	"./year_report_pt.json": 7852,
	"./year_report_ru.json": 8919,
	"./year_report_th.json": 9229,
	"./year_report_tr.json": 310,
	"./year_report_tw.json": 8670,
	"./year_report_uk.json": 1138,
	"./year_report_vn.json": 5177,
	"./year_report_zh.json": 8188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6354;